import styled from 'styled-components';
import {
  FilterType,
  ResidentialAreaData,
  CommercialAreaData,
  IndustrialAreaData,
  GreenAreaData,
  ManagementAreaData,
  ExtractionAreaData,
  UseDistrictData,
  UseAreaData,
} from '../FilterData';

interface Props {
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

const UseArea = ({ filters, setFilters }: Props) => {
  const allSelected1 = ResidentialAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected2 = CommercialAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected3 = IndustrialAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected4 = GreenAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected5 = ManagementAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected6 = ExtractionAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected7 = UseDistrictData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const allSelected8 = UseAreaData.every((item) =>
    filters.multiUseArea.includes(item.name),
  );
  const isSelectedAllOptions =
    allSelected1 &&
    allSelected2 &&
    allSelected3 &&
    allSelected4 &&
    allSelected5 &&
    allSelected6 &&
    allSelected7 &&
    allSelected8;

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,
      useArea: [],
      multiUseArea: filters.multiUseArea.includes(value)
        ? filters.multiUseArea.filter((v) => v !== value)
        : [...filters.multiUseArea, value],
    });
  };
  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        useArea: [],
        multiUseArea: filters.multiUseArea.filter(
          (name) => !data.some((item) => item.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,
        useArea: [],
        multiUseArea: Array.from(
          new Set([...filters.multiUseArea, ...data.map((item) => item.name)]),
        ),
      });
    }
  };

  return (
    <AllOptionBox>
      <AllOptionBoxContent>
        <BlockContainer>
          <OptionItem
            onClick={() => {
              if (isSelectedAllOptions) {
                setFilters({
                  ...filters,
                  multiUseArea: [],
                });
              } else {
                toggleAllSelect(isSelectedAllOptions, [
                  ...ResidentialAreaData,
                  ...CommercialAreaData,
                  ...IndustrialAreaData,
                  ...GreenAreaData,
                  ...ManagementAreaData,
                  ...ExtractionAreaData,
                  ...UseDistrictData,
                  ...UseAreaData,
                ]);
              }
            }}
          >
            <img
              src={`/assets/images/check/${isSelectedAllOptions ? 'check-blue-on' : 'check-blue-off'}.svg`}
              alt="Check"
            />
            <span>전체선택</span>
          </OptionItem>
        </BlockContainer>
        <BlockContainer>
          <div>도시지역</div>
          <Block>
            <BlockTitle>주거지역</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected1, ResidentialAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>주거지역 전체</span>
              </OptionItem>
              {ResidentialAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>상업지역</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected2, CommercialAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>상업지역 전체</span>
              </OptionItem>
              {CommercialAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>공업지역</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected3, IndustrialAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>공업지역 전체</span>
              </OptionItem>
              {IndustrialAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>녹지지역</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected4, GreenAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>녹지지역 전체</span>
              </OptionItem>
              {GreenAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>관리지역</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected5, ManagementAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected5 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>관리지역 전체</span>
              </OptionItem>
              {ManagementAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>기타지역</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected6, ExtractionAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected6 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>기타지역 전체</span>
              </OptionItem>
              {ExtractionAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>용도지구</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected7, UseDistrictData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected7 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>용도지구 전체</span>
              </OptionItem>
              {UseDistrictData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer style={{ borderBottom: 'none' }}>
          <div>용도구역</div>
          <Block>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected8, UseAreaData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected8 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>용도구역 전체</span>
              </OptionItem>
              {UseAreaData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.value);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiUseArea.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};
export default UseArea;

interface Props2 {
  filters: any;
  setFilters: (filters: any) => void;
  nonBorder?: boolean;
}

export const UseArea2 = ({ filters, setFilters, nonBorder }: Props2) => {
  const allSelected1 = ResidentialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected2 = CommercialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected3 = IndustrialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected4 = GreenAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected5 = ManagementAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected6 = ExtractionAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected7 = UseDistrictData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected8 = UseAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,

      useArea: filters.useArea.includes(value)
        ? filters.useArea.filter((v: any) => v !== value)
        : [...filters.useArea, value],
    });
  };
  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        useArea: filters.useArea.filter(
          (name: string) => !data.some((item) => item.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,

        useArea: Array.from(
          new Set([...filters.useArea, ...data.map((item) => item.name)]),
        ),
      });
    }
  };
  const AllSelectedBox =
    allSelected1 &&
    allSelected2 &&
    allSelected3 &&
    allSelected4 &&
    allSelected5 &&
    allSelected6 &&
    allSelected7 &&
    allSelected8;

  return (
    <AllOptionBox
      style={{ borderBottom: nonBorder ? 'none' : '1px solid #e8e9ea' }}
    >
      <BlockContainer>
        <AllSelectBox>
          <img
            onClick={() => {
              if (AllSelectedBox) {
                setFilters({
                  ...filters,
                  useArea: [],
                });
              } else {
                toggleAllSelect(AllSelectedBox, [
                  ...ResidentialAreaData,
                  ...CommercialAreaData,
                  ...IndustrialAreaData,
                  ...GreenAreaData,
                  ...ManagementAreaData,
                  ...ExtractionAreaData,
                  ...UseDistrictData,
                  ...UseAreaData,
                ]);
              }
            }}
            src={`/assets/images/check/${AllSelectedBox ? 'check-blue-on' : 'check-blue-off'}.svg`}
          ></img>
          <div>전체선택</div>
        </AllSelectBox>
      </BlockContainer>
      <AllOptionBoxContent>
        <BlockContainer>
          <div>도시지역</div>
          <Block>
            <BlockTitle>주거지역</BlockTitle>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() =>
                  toggleAllSelect(allSelected1, ResidentialAreaData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>주거지역 전체</span>
              </OptionItem>
              {ResidentialAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>상업지역</BlockTitle>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() =>
                  toggleAllSelect(allSelected2, CommercialAreaData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>상업지역 전체</span>
              </OptionItem>
              {CommercialAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>공업지역</BlockTitle>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() =>
                  toggleAllSelect(allSelected3, IndustrialAreaData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>공업지역 전체</span>
              </OptionItem>
              {IndustrialAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
          <Block>
            <BlockTitle>녹지지역</BlockTitle>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() => toggleAllSelect(allSelected4, GreenAreaData)}
              >
                <img
                  src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>녹지지역 전체</span>
              </OptionItem>
              {GreenAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>관리지역</div>
          <Block>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() =>
                  toggleAllSelect(allSelected5, ManagementAreaData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected5 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>관리지역 전체</span>
              </OptionItem>
              {ManagementAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>기타지역</div>
          <Block>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() =>
                  toggleAllSelect(allSelected6, ExtractionAreaData)
                }
              >
                <img
                  src={`/assets/images/check/${allSelected6 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>관리지역 전체</span>
              </OptionItem>
              {ExtractionAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer>
          <div>용도지구</div>
          <Block>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() => toggleAllSelect(allSelected7, UseDistrictData)}
              >
                <img
                  src={`/assets/images/check/${allSelected7 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>용도지구 전체</span>
              </OptionItem>
              {UseDistrictData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
        <BlockContainer style={{ borderBottom: 'none' }}>
          <div>용도구역</div>
          <Block>
            <BlockContent>
              <OptionItem
                style={{
                  width: '100%',
                }}
                onClick={() => toggleAllSelect(allSelected8, UseAreaData)}
              >
                <img
                  src={`/assets/images/check/${allSelected8 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>용도구역 전체</span>
              </OptionItem>
              {UseAreaData.map((item: any, index: number) => (
                <OptionItem key={index} onClick={() => toggleFilter(item.name)}>
                  <img
                    src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        </BlockContainer>
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};

const AllSelectBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;
const AllOptionBox = styled.div`
  width: 100%;
  margin-top: 2px;
  border: 1px solid #e1e2e4;
  border-radius: 8px;
`;

const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #222;
  padding: 12px;
  border-bottom: 1px solid #e1e2e4;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: rgba(23, 30, 38, 0.78);
`;
const BlockContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;
const OptionItem = styled.div`
  display: flex;
  width: calc((100% - 12px) / 2);
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  gap: 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
  white-space: nowrap;
`;

const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
